/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Col_AttemptsInputs */

const vi_print_admin_col_attempts = /** @type {(inputs: Print_Admin_Col_AttemptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lần`)
};

/**

* @param {Print_Admin_Col_AttemptsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_col_attempts = /** @type {((inputs?: Print_Admin_Col_AttemptsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Col_AttemptsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_col_attempts(inputs)
});